/* Auto-generated by qa-runner/tools/build_final_week_manifest.mjs. Do not edit manually. */
(function (root, factory) {
  var manifest = factory();
  if (typeof module === "object" && module.exports) module.exports = manifest;
  if (root) root.CYRFinalWeekManifest = manifest;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";
  return {
  "schemaVersion": 1,
  "campaignId": "cyr6-final-week-2026",
  "brandKey": "SS",
  "brandName": "The Stealth Society",
  "enabled": true,
  "bannerEnabled": true,
  "dateSource": "shopify_metafields",
  "campaignCloseOffsetDays": 1,
  "campaignEndLocalTime": "04:00",
  "graceEndLocalTime": "12:00",
  "fallbackPath": "/enter-giveaway",
  "targetPolicy": "daily_first_same_lane_then_family_primary",
  "allowedQueryParameters": [
    "utm_*",
    "_kx",
    "preview_theme_id",
    "_ab",
    "_fd",
    "_sc"
  ],
  "offers": [
    {
      "id": "7d-1",
      "path": "/pages/7d-1",
      "daysBeforeGiveawayEnd": 6,
      "sendLocalTime": "15:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 10000,
      "price": 29.99,
      "productName": "Bronze Digital Pack [40 Digital Posters]",
      "baselineRowId": "LPBASE-SS-24"
    },
    {
      "id": "7d-1-fu",
      "path": "/pages/7d-1-fu",
      "daysBeforeGiveawayEnd": 6,
      "sendLocalTime": "16:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 10000,
      "price": 14.99,
      "productName": "50% OFF: Bronze Digital Pack [40 Digital Posters]",
      "baselineRowId": "LPBASE-SS-25"
    },
    {
      "id": "6d-1",
      "path": "/pages/6d-1",
      "daysBeforeGiveawayEnd": 5,
      "sendLocalTime": "15:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 20000,
      "price": 29.99,
      "productName": "Silver Digital Pack [50 Digital Posters]",
      "baselineRowId": "LPBASE-SS-26"
    },
    {
      "id": "6d-1-fu",
      "path": "/pages/6d-1-fu",
      "daysBeforeGiveawayEnd": 5,
      "sendLocalTime": "16:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 20000,
      "price": 14.99,
      "productName": "50% OFF: Silver Digital Pack [50 Digital Posters]",
      "baselineRowId": "LPBASE-SS-27"
    },
    {
      "id": "5d-1",
      "path": "/pages/5d-1",
      "daysBeforeGiveawayEnd": 4,
      "sendLocalTime": "15:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 30000,
      "price": 29.99,
      "productName": "Gold Digital Pack [60 Digital Posters]",
      "baselineRowId": "LPBASE-SS-28"
    },
    {
      "id": "5d-1-fu",
      "path": "/pages/5d-1-fu",
      "daysBeforeGiveawayEnd": 4,
      "sendLocalTime": "16:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 30000,
      "price": 14.99,
      "productName": "50% OFF: Gold Digital Pack [60 Digital Posters]",
      "baselineRowId": "LPBASE-SS-29"
    },
    {
      "id": "4d-1",
      "path": "/pages/4d-1",
      "daysBeforeGiveawayEnd": 3,
      "sendLocalTime": "11:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 40000,
      "price": 29.99,
      "productName": "Platinum Digital Pack [70 Digital Posters]",
      "baselineRowId": "LPBASE-SS-30"
    },
    {
      "id": "4d-1-fu",
      "path": "/pages/4d-1-fu",
      "daysBeforeGiveawayEnd": 3,
      "sendLocalTime": "12:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 40000,
      "price": 14.99,
      "productName": "50% OFF: Platinum Digital Pack [70 Digital Posters]",
      "baselineRowId": "LPBASE-SS-31"
    },
    {
      "id": "4d-2",
      "path": "/pages/4d-2",
      "daysBeforeGiveawayEnd": 3,
      "sendLocalTime": "15:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 50000,
      "price": 29.99,
      "productName": "Diamond Digital Pack [80 Digital Posters]",
      "baselineRowId": "LPBASE-SS-32"
    },
    {
      "id": "4d-2-fu",
      "path": "/pages/4d-2-fu",
      "daysBeforeGiveawayEnd": 3,
      "sendLocalTime": "16:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 50000,
      "price": 14.99,
      "productName": "50% OFF: Diamond Digital Pack [80 Digital Posters]",
      "baselineRowId": "LPBASE-SS-33"
    },
    {
      "id": "3d-1",
      "path": "/pages/3d-1",
      "daysBeforeGiveawayEnd": 2,
      "sendLocalTime": "11:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 60000,
      "price": 29.99,
      "productName": "Titanium Digital Pack [90 Digital Posters]",
      "baselineRowId": "LPBASE-SS-34"
    },
    {
      "id": "3d-1-fu",
      "path": "/pages/3d-1-fu",
      "daysBeforeGiveawayEnd": 2,
      "sendLocalTime": "12:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 60000,
      "price": 14.99,
      "productName": "50% OFF: Titanium Digital Pack [90 Digital Posters]",
      "baselineRowId": "LPBASE-SS-35"
    },
    {
      "id": "3d-2",
      "path": "/pages/3d-2",
      "daysBeforeGiveawayEnd": 2,
      "sendLocalTime": "13:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 70000,
      "price": 29.99,
      "productName": "Obsidian Digital Pack [100 Digital Posters]",
      "baselineRowId": "LPBASE-SS-36"
    },
    {
      "id": "3d-2-fu",
      "path": "/pages/3d-2-fu",
      "daysBeforeGiveawayEnd": 2,
      "sendLocalTime": "14:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 70000,
      "price": 14.99,
      "productName": "50% OFF: Obsidian Digital Pack [100 Digital Posters]",
      "baselineRowId": "LPBASE-SS-37"
    },
    {
      "id": "3d-3",
      "path": "/pages/3d-3",
      "daysBeforeGiveawayEnd": 2,
      "sendLocalTime": "15:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 80000,
      "price": 29.99,
      "productName": "Emerald Digital Pack [110 Digital Posters]",
      "baselineRowId": "LPBASE-SS-38"
    },
    {
      "id": "ol-3d-1",
      "path": "/pages/ol-3d-1",
      "daysBeforeGiveawayEnd": 2,
      "sendLocalTime": "15:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 1000000,
      "price": 29.99,
      "productName": "Titanium Digital Pack [90 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-59"
    },
    {
      "id": "3d-3-fu",
      "path": "/pages/3d-3-fu",
      "daysBeforeGiveawayEnd": 2,
      "sendLocalTime": "16:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 80000,
      "price": 14.99,
      "productName": "50% OFF: Emerald Digital Pack [110 Digital Posters]",
      "baselineRowId": "LPBASE-SS-39"
    },
    {
      "id": "ol-3d-1-fu",
      "path": "/pages/ol-3d-1-fu",
      "daysBeforeGiveawayEnd": 2,
      "sendLocalTime": "16:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 1000000,
      "price": 14.99,
      "productName": "50% OFF: Titanium Digital Pack [90 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-60"
    },
    {
      "id": "2d-1",
      "path": "/pages/2d-1",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "11:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 100000,
      "price": 29.99,
      "productName": "Sapphire Digital Pack [120 Digital Posters]",
      "baselineRowId": "LPBASE-SS-40"
    },
    {
      "id": "ol-2d-1",
      "path": "/pages/ol-2d-1",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "11:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 2000000,
      "price": 29.99,
      "productName": "Sapphire Digital Pack [120 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-61"
    },
    {
      "id": "2d-1-fu",
      "path": "/pages/2d-1-fu",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "12:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 100000,
      "price": 14.99,
      "productName": "50% OFF: Sapphire Digital Pack [120 Digital Posters]",
      "baselineRowId": "LPBASE-SS-41"
    },
    {
      "id": "ol-2d-1-fu",
      "path": "/pages/ol-2d-1-fu",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "12:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 2000000,
      "price": 14.99,
      "productName": "50% OFF: Sapphire Digital Pack [120 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-62"
    },
    {
      "id": "2d-2",
      "path": "/pages/2d-2",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "13:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 250000,
      "price": 19.99,
      "productName": "Ruby Digital Pack [130 Digital Posters]",
      "baselineRowId": "LPBASE-SS-42"
    },
    {
      "id": "ol-2d-2",
      "path": "/pages/ol-2d-2",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "13:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 3000000,
      "price": 19.99,
      "productName": "Ruby Digital Pack [130 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-63"
    },
    {
      "id": "2d-2-fu",
      "path": "/pages/2d-2-fu",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "14:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 250000,
      "price": 9.99,
      "productName": "50% OFF: Ruby Digital Pack [130 Digital Posters]",
      "baselineRowId": "LPBASE-SS-43"
    },
    {
      "id": "ol-2d-2-fu",
      "path": "/pages/ol-2d-2-fu",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "14:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 3000000,
      "price": 9.99,
      "productName": "50% OFF: Ruby Digital Pack [130 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-64"
    },
    {
      "id": "2d-3",
      "path": "/pages/2d-3",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "15:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 500000,
      "price": 19.99,
      "productName": "Onyx Digital Pack [140 Digital Posters]",
      "baselineRowId": "LPBASE-SS-44"
    },
    {
      "id": "ol-2d-3",
      "path": "/pages/ol-2d-3",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "15:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 4000000,
      "price": 19.99,
      "productName": "Onyx Digital Pack [140 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-65"
    },
    {
      "id": "2d-3-fu",
      "path": "/pages/2d-3-fu",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "16:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 500000,
      "price": 9.99,
      "productName": "50% OFF: Onyx Digital Pack [140 Digital Posters]",
      "baselineRowId": "LPBASE-SS-45"
    },
    {
      "id": "ol-2d-3-fu",
      "path": "/pages/ol-2d-3-fu",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "16:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 4000000,
      "price": 9.99,
      "productName": "50% OFF: Onyx Digital Pack [140 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-66"
    },
    {
      "id": "2d-4",
      "path": "/pages/2d-4",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "17:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 750000,
      "price": 19.99,
      "productName": "Topaz Digital Pack [150 Digital Posters]",
      "baselineRowId": "LPBASE-SS-46"
    },
    {
      "id": "ol-2d-4",
      "path": "/pages/ol-2d-4",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "17:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 5000000,
      "price": 19.99,
      "productName": "Topaz Digital Pack [150 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-67"
    },
    {
      "id": "2d-4-fu",
      "path": "/pages/2d-4-fu",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "18:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 750000,
      "price": 9.99,
      "productName": "50% OFF: Topaz Digital Pack [150 Digital Posters]",
      "baselineRowId": "LPBASE-SS-47"
    },
    {
      "id": "ol-2d-4-fu",
      "path": "/pages/ol-2d-4-fu",
      "daysBeforeGiveawayEnd": 1,
      "sendLocalTime": "18:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 5000000,
      "price": 9.99,
      "productName": "50% OFF: Topaz Digital Pack [150 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-68"
    },
    {
      "id": "1d-1",
      "path": "/pages/1d-1",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "11:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 1000000,
      "price": 29.99,
      "productName": "Amethyst Digital Pack [160 Digital Posters]",
      "baselineRowId": "LPBASE-SS-48"
    },
    {
      "id": "ol-1d-1",
      "path": "/pages/ol-1d-1",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "11:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 6000000,
      "price": 29.99,
      "productName": "Amethyst Digital Pack [160 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-69"
    },
    {
      "id": "1d-1-fu",
      "path": "/pages/1d-1-fu",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "12:30",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 1000000,
      "price": 14.99,
      "productName": "50% OFF: Amethyst Digital Pack [160 Digital Posters]",
      "baselineRowId": "LPBASE-SS-49"
    },
    {
      "id": "ol-1d-1-fu",
      "path": "/pages/ol-1d-1-fu",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "12:30",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 6000000,
      "price": 14.99,
      "productName": "50% OFF: Amethyst Digital Pack [160 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-70"
    },
    {
      "id": "1d-2",
      "path": "/pages/1d-2",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "13:15",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 2500000,
      "price": 19.99,
      "productName": "Meteor Digital Pack [170 Digital Posters]",
      "baselineRowId": "LPBASE-SS-50"
    },
    {
      "id": "ol-1d-2",
      "path": "/pages/ol-1d-2",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "13:15",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 7000000,
      "price": 19.99,
      "productName": "Meteor Digital Pack [170 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-71"
    },
    {
      "id": "1d-2-fu",
      "path": "/pages/1d-2-fu",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "14:00",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 2500000,
      "price": 9.99,
      "productName": "50% OFF: Meteor Digital Pack [170 Digital Posters]",
      "baselineRowId": "LPBASE-SS-51"
    },
    {
      "id": "ol-1d-2-fu",
      "path": "/pages/ol-1d-2-fu",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "14:00",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 7000000,
      "price": 9.99,
      "productName": "50% OFF: Meteor Digital Pack [170 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-72"
    },
    {
      "id": "1d-3",
      "path": "/pages/1d-3",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "14:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 5000000,
      "price": 19.99,
      "productName": "Galaxy Digital Pack [180 Digital Posters]",
      "baselineRowId": "LPBASE-SS-52"
    },
    {
      "id": "ol-1d-3",
      "path": "/pages/ol-1d-3",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "14:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 8000000,
      "price": 19.99,
      "productName": "Galaxy Digital Pack [180 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-73"
    },
    {
      "id": "1d-3-fu",
      "path": "/pages/1d-3-fu",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "15:30",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 5000000,
      "price": 9.99,
      "productName": "50% OFF: Galaxy Digital Pack [180 Digital Posters]",
      "baselineRowId": "LPBASE-SS-53"
    },
    {
      "id": "ol-1d-3-fu",
      "path": "/pages/ol-1d-3-fu",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "15:30",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 8000000,
      "price": 9.99,
      "productName": "50% OFF: Galaxy Digital Pack [180 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-74"
    },
    {
      "id": "1d-4",
      "path": "/pages/1d-4",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "16:15",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 7500000,
      "price": 9.99,
      "productName": "Cosmic Digital Pack [190 Digital Posters]",
      "baselineRowId": "LPBASE-SS-54"
    },
    {
      "id": "ol-1d-4",
      "path": "/pages/ol-1d-4",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "16:15",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 9000000,
      "price": 9.99,
      "productName": "Cosmic Digital Pack [190 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-75"
    },
    {
      "id": "1d-4-fu",
      "path": "/pages/1d-4-fu",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "17:00",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 7500000,
      "price": 4.99,
      "productName": "50% OFF: Cosmic Digital Pack [190 Digital Posters]",
      "baselineRowId": "LPBASE-SS-55"
    },
    {
      "id": "ol-1d-4-fu",
      "path": "/pages/ol-1d-4-fu",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "17:00",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 9000000,
      "price": 4.99,
      "productName": "50% OFF: Cosmic Digital Pack [190 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-76"
    },
    {
      "id": "1d-5",
      "path": "/pages/1d-5",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "17:45",
      "sendTimeBasis": "recipient_local",
      "lane": "new_primary",
      "entries": 10000000,
      "price": 9.99,
      "productName": "Legendary Digital Pack [200 Digital Posters]",
      "baselineRowId": "LPBASE-SS-56"
    },
    {
      "id": "ol-1d-5",
      "path": "/pages/ol-1d-5",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "17:45",
      "sendTimeBasis": "recipient_local",
      "lane": "old_primary",
      "entries": 10000000,
      "price": 9.99,
      "productName": "Legendary Digital Pack [200 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-77"
    },
    {
      "id": "1d-5-fu-ph",
      "path": "/pages/1d-5-fu-ph",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "18:30",
      "sendTimeBasis": "recipient_local",
      "lane": "new_follow_up",
      "entries": 10000000,
      "price": 4.99,
      "productName": "50% OFF: Legendary Digital Pack [200 Digital Posters]",
      "baselineRowId": "LPBASE-SS-58"
    },
    {
      "id": "ol-1d-5-fu-ph",
      "path": "/pages/ol-1d-5-fu-ph",
      "daysBeforeGiveawayEnd": 0,
      "sendLocalTime": "18:30",
      "sendTimeBasis": "recipient_local",
      "lane": "old_follow_up",
      "entries": 10000000,
      "price": 4.99,
      "productName": "50% OFF: Legendary Digital Pack [200 Digital Posters] OL",
      "baselineRowId": "LPBASE-SS-79"
    }
  ]
};
});
